module.exports = "/assets/42cb157134bb1ba7f41f2412bcb332a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AK.png
// module id = 2327
// module chunks = 0